export function preloader() {
  const loadedFirstTime = localStorage.getItem("loadedFirstTime");

  if (!loadedFirstTime) {
    document.body.classList.add("is-preloader");
    setTimeout(function () {
      document.body.classList.add("loaded-first-time");
      localStorage.setItem("loadedFirstTime", "true");
    }, 3000);
  } else {
    document.body.classList.add("loaded-first-time");
  }
}
